
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ApiserviceService } from './apiservice.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from "./components/home/home.component";
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { environment } from '../environments/environment';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, filter, take } from 'rxjs';
import { SharedModelComponent } from '../shared/components/shared-model/shared-model.component';
import { CartDetailsService } from '../shared/services/cart-details.service';
import { DataLayerService } from '../shared/services/gtm-service/data-layer.service';
import { HttpService } from '../shared/services/http.service';
import { JsonDataService } from '../shared/services/json-data.service';
import { RouteService } from '../shared/services/router.service';
import { SchemaService } from '../shared/services/schema.service';
import { UpdateService } from '../shared/services/update.service';
import { UtilsService } from '../shared/services/utils.service';
import { InbtHomepageService } from '../shared/services/inbt-homepage.service';
import { CartService } from '../shared/services/cart.service';
import { SignInService } from '../shared/services/sign-in.service';
import { InbtMotherCategoryComponent } from './components/inbt-mother-category/inbt-mother-category.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RedirectService } from '../shared/services/redirect.service';
import { Meta } from '@angular/platform-browser';
import { SpinnerComponent } from "./components/spinner/spinner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, MatProgressSpinnerModule, HeaderComponent, FooterComponent, HomeComponent, ContactUsComponent, InbtMotherCategoryComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [HttpClient]
})
export class AppComponent implements OnInit, AfterViewInit {
  environment: any = environment;
  isCookieModelOpened: boolean = false;
  isCartModified: boolean = false;
  showTicker: boolean = false;
  showCalcButton: boolean = false;
  hideCalcButton: boolean = false;
  cartInfo$: any = [];
  sub: Subscription = new Subscription();
  updateVar: any = Subscription.EMPTY;
  _routerSub: any = Subscription.EMPTY;
  showHeader: boolean = true;
  activeRouter: string = '';
  showFooter: boolean = false;
  showHtml: any;
  nonce: any;
  showForceUpdate: any;
  private tawkLoaded = false;
  private observer: MutationObserver | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public dataLayer: DataLayerService,
    public utils: UtilsService,
    public router: Router,
    private SigninService: SignInService,
    private httpSvc: HttpService,
    public dialog: MatDialog,
    public routerService: RouteService,
    public CartService: CartService,
    public service: CartDetailsService,
    private sw: UpdateService,
    private schemaService: SchemaService,
    private jsonDataService: JsonDataService,
    private _renderer2: Renderer2,
    private homeSvc: InbtHomepageService,
    private el: ElementRef,
    @Inject(DOCUMENT) private _document: Document,
    private meta: Meta,
    private redirectService: RedirectService
  ) {
    this.nonce = this.getCspNonce();
    console.log('[CSP] Initialized nonce:', this.nonce);
    this.sub.add(this.httpSvc.getRedirectUrl(this.router.url).subscribe((data: any) => {
      if (data && data['res'] && data.res.url) {
        this.router.navigate([data.res.url]);
      }
    }));
    utils.userPinCode = utils.getUserPicode();
    if (isPlatformBrowser(this.platformId)) {
      this.setViewSize(window.innerWidth, window.innerHeight);
      this.sub.add(utils.showHeaderFooter.subscribe((data: any) => {
        this.showHtml = data;
        this.checkCookiesModel();
      }));
    }
  }

  private getCspNonce(): string | null {
    const metaTag = this._document.querySelector('meta[property="csp-nonce"]');
    const nonce = metaTag?.getAttribute('content') || null;
    console.log('[CSP] Retrieved nonce from meta tag:', nonce);
    return nonce;
  }

  ngOnInit() {
    this.sub.add(
      this.router.events.pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart)
      ).subscribe((event: NavigationStart) => {
        this.checkRedirect(event.url);
      })
    );
    if (isPlatformBrowser(this.platformId)) {

      this.SigninService.autoAuthUser();
      const encryptedCart: any = localStorage.getItem('cart');
      const decryptedCart = this.utils.decryptarrayText(encryptedCart);
      let cartItems: any = decryptedCart;
      if(cartItems && cartItems != null && cartItems != "null"){

        this.CartService.setInfo(JSON.parse(cartItems), false);
      }
      this.CartService.clearBuynow();
      this.sub.add(this._routerSub = this.router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe((_event: any) => {
          this.utils.subscribedEmail = '';
          let activeRouter = this.utils.getActiveRouter(this.router.url);
          const headerElement = this.el.nativeElement.querySelector('app-header');
          const footerElement = this.el.nativeElement.querySelector('app-footer');
          const htmlElement = document.documentElement;
          if (headerElement && footerElement && htmlElement) {
            headerElement.style.display = (activeRouter != 'manuals' || !activeRouter) ? 'block' : 'none';
            footerElement.style.display = (activeRouter != 'manuals' || !activeRouter) ? 'block' : 'none';
            htmlElement.style.overflow = (activeRouter != 'manuals' || !activeRouter) ? 'auto' : 'hidden';
          }
          let activeRoute = this.utils.getActiveRouterWhileParams(this.router.url);
          if (activeRoute != '/load-calculator' && activeRoute != '/recommended-solution') {
            localStorage.removeItem('loadCalculatorData');
            localStorage.removeItem('avgRunningLoad');
            localStorage.removeItem('totalWatts');
            localStorage.removeItem('backupReq');
          }
          if (activeRoute != '/solar-calculator' && activeRoute != '/recommended-solution') {
            localStorage.removeItem('solarCalculatorData');
          }
          this.showCalcButton = window.innerWidth >= 768 && (activeRouter === 'shop-now' || activeRouter === 'offers' || this.router.url.includes('inverter-battery-combo'));
          this.hideCalcButton = activeRouter === 'ampseries_avl' || activeRouter.includes('manuals');
          if (this.router.url == '/') {
            this.getCartItems();
          }
        }));

      this.sub.add(this.updateVar = this.utils.showForceUpdate.subscribe((data) => {
        if (data) {
          this.showForceUpdate = true;
        } else {
          this.showForceUpdate = false;
        }
      }));
      if (isPlatformBrowser(this.platformId)) {
        window.addEventListener('scroll', () => {
          const windowHeight = window.innerHeight;
          const scrollY = window.scrollY;
          const bodyOffsetHeight = document.body.offsetHeight;
          let viewportType;
          if (this.utils.screenSizeObj.width < 576) {
            viewportType = 'mobile';
          } else if (this.utils.screenSizeObj.width < 768) {
            viewportType = 'tab';
          } else {
            viewportType = 'desktop';
          }
          if (viewportType === 'desktop' || (viewportType === 'tab' && scrollY + windowHeight >= bodyOffsetHeight) || (viewportType === 'mobile' && scrollY + windowHeight + 300 >= bodyOffsetHeight)) {
            if (this.activeRouter !== 'manuals' || !this.activeRouter) {
              this.showFooter = true;
            } else {
              this.showFooter = false;
            }
          }
        });
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Ensure nonce is initialized
      this.initializeTawkTo();

      // Check for existing CSP meta tag
      const head = this._document.head;
      const metaTags = this._renderer2.selectRootElement('meta[http-equiv="Content-Security-Policy"]', true);
      if (!metaTags) {
        this.setupCSP();
      }
      // this.processHeadStyles();
      // this.processInlineStylesInTemplate();
      this.applyNonceToHeadElements(); // Apply nonce to all style and script tags after operations
      this.observeHeadStyles(); // New: Observe <head> for dynamically added <style> tags
    }
  }
  private observeHeadStyles(): void {
    if (!isPlatformBrowser(this.platformId)) {
      console.warn('[CSP] Skipping observeHeadStyles: not in browser environment');
      return;
    }

    try {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'STYLE') {
              const style = node as any;
              const nonce = style.getAttribute('nonce');
              if (!nonce || nonce.trim() === '') {
                console.warn('[CSP] New style tag detected in head without nonce:', style.textContent.substring(0, 50) + '...');
                this._renderer2.setAttribute(style, 'nonce', this.nonce);
                const nonceSet = style.getAttribute('nonce');
                if (nonceSet === this.nonce) {
                  console.log('[CSP] Successfully applied nonce to new style tag:', style.id || 'unnamed', 'Nonce:', nonceSet);
                } else {
                  console.error('[CSP] Failed to apply nonce to new style tag:', style.id || 'unnamed', 'Actual:', nonceSet, 'Expected:', this.nonce);
                  this._renderer2.setAttribute(style, 'nonce', this.nonce); // Retry
                }
              }
            }
          });
        });
      });

      observer.observe(this._document.head, {
        childList: true,
        subtree: false,
      });
      console.log('[CSP] MutationObserver started for <head> style tags');
    } catch (error) {
      console.error('[CSP] Error setting up head style observer:', error);
    }
  }
  private applyNonceToHeadElements(): void {
    if (!isPlatformBrowser(this.platformId)) {
      console.warn('[CSP] Skipping applyNonceToHeadElements: not in browser environment');
      return;
    }

    try {
      // Ensure nonce is valid
      if (!this.nonce) {
        this.nonce = Math.random().toString(36).substring(2, 15);
        console.warn('[CSP] Nonce was missing in applyNonceToHeadElements, generated fallback nonce:', this.nonce);
      }

      // Apply nonce to style tags
      const styleTags = Array.from(this._document.head.getElementsByTagName('style'));
      let styleNoNonceCount = 0;
      styleTags.forEach((style: HTMLElement) => {
        const nonce = style.getAttribute('nonce');
        if (!nonce || nonce.trim() === '') {
          styleNoNonceCount++;
          this._renderer2.setAttribute(style, 'nonce', this.nonce);
          const nonceSet = style.getAttribute('nonce');
          if (nonceSet === this.nonce) {
            console.log('[CSP] Successfully applied nonce to style tag:', style.id || 'unnamed', 'Nonce:', nonceSet);
          } else {
            console.error('[CSP] Failed to apply nonce to style tag:', style.id || 'unnamed', 'Actual:', nonceSet, 'Expected:', this.nonce);
            this._renderer2.setAttribute(style, 'nonce', this.nonce); // Retry
          }
        }
      });
      console.log(`[CSP] Total style tags in head without nonce updated: ${styleNoNonceCount}`);

      // Apply nonce to script tags
      const scriptTags = Array.from(this._document.head.getElementsByTagName('script'));
      let scriptNoNonceCount = 0;
      scriptTags.forEach((script: HTMLElement) => {
        const nonce = script.getAttribute('nonce');
        if (!nonce || nonce.trim() === '') {
          scriptNoNonceCount++;
          this._renderer2.setAttribute(script, 'nonce', this.nonce);
          const nonceSet = script.getAttribute('nonce');
          if (nonceSet === this.nonce) {
            console.log('[CSP] Successfully applied nonce to script tag:', script.getAttribute('src') || 'inline', 'Nonce:', nonceSet);
          } else {
            console.error('[CSP] Failed to apply nonce to script tag:', script.getAttribute('src') || 'inline', 'Actual:', nonceSet, 'Expected:', this.nonce);
            this._renderer2.setAttribute(script, 'nonce', this.nonce); // Retry
          }
        }
      });
      console.log(`[CSP] Total script tags in head without nonce updated: ${scriptNoNonceCount}`);

      // Verify nonce in DOM
      const verifiedStyles = Array.from(this._document.head.getElementsByTagName('style')).filter(
        style => style.getAttribute('nonce') === this.nonce
      );
      const verifiedScripts = Array.from(this._document.head.getElementsByTagName('script')).filter(
        script => script.getAttribute('nonce') === this.nonce
      );
      console.log(`[CSP] Total style tags in head with nonce verified: ${verifiedStyles.length}`);
      console.log(`[CSP] Total script tags in head with nonce verified: ${verifiedScripts.length}`);
    } catch (error) {
      console.error('[CSP] Error applying nonce to head elements:', error);
    }
  }
  initializeTawkTo(): void {
    if (isPlatformBrowser(this.platformId) && !this.tawkLoaded) {
      try {
        this.applyTawkGlobalStyles();
        this.observeTawkWidgetCreation();
        this.processIframes()
        this.loadTawkScript();
        this.tawkLoaded = true;
      } catch (error) {
        console.error('[Tawk.to] Error initializing Tawk.to:', error);
      }
    }
  }

  private loadTawkScript(): void {
    const tawkScript = this._renderer2.createElement('script');
    this._renderer2.setAttribute(tawkScript, 'type', 'text/javascript');
    this._renderer2.setAttribute(tawkScript, 'nonce', this.nonce);
    this._renderer2.setAttribute(tawkScript, 'src', 'https://embed.tawk.to/5b4462b96d961556373d90c7/default');
    this._renderer2.setAttribute(tawkScript, 'async', 'true');
    this._renderer2.setAttribute(tawkScript, 'charset', 'UTF-8');
    this._renderer2.setAttribute(tawkScript, 'crossorigin', '*');
    this._renderer2.appendChild(this._document.head, tawkScript);

    this._renderer2.listen(tawkScript, 'load', () => {
      console.log('[Tawk.to] Script loaded successfully');
      this.processIframesAndStyles();
    });
    this._renderer2.listen(tawkScript, 'error', (error: any) => {
      console.error('[Tawk.to] Error loading script:', error);
    });
  }

  private observeTawkWidgetCreation(): void {
    if (this.observer) return;

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Process added nodes
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as HTMLElement;
            // Handle iframes
            if (element.tagName === 'IFRAME' && (element as HTMLIFrameElement).src?.includes('tawk.to')) {
              this.processTawkIframe(element as HTMLIFrameElement);
            }
            // Handle style tags
            if (element.tagName === 'STYLE') {
              this.processStyleElement(element as HTMLStyleElement);
            }
            // Handle elements with inline styles
            if (element.hasAttribute('style')) {
              this.convertInlineStyleToStyleElement(element, element.getAttribute('style')!, 'tawk');
            }
            // Process nested iframes and elements
            const iframes = Array.from(element.getElementsByTagName('iframe')).filter(
              iframe => iframe.src.includes('tawk.to')
            );
            iframes.forEach((iframe) => this.processTawkIframe(iframe as HTMLIFrameElement));
            const styledElements = Array.from(element.getElementsByTagName('*')).filter(
              el => el.hasAttribute('style') && !el.className.includes('tawk-style')
            );
            styledElements.forEach((el) =>
              this.convertInlineStyleToStyleElement(el as HTMLElement, el.getAttribute('style')!, 'tawk')
            );
          }
        });
        // Process attribute changes (e.g., style attribute added)
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const element = mutation.target as HTMLElement;
          if (element.hasAttribute('style')) {
            this.convertInlineStyleToStyleElement(element, element.getAttribute('style')!, 'tawk');
          }
        }
      });
    });

    this.observer.observe(this._document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'id']
    });
    console.log('[Tawk.to] Mutation observer started');
  }

  private processTawkIframe(iframe: HTMLIFrameElement): void {
    try {
      if (!iframe.getAttribute('nonce')) {
        this._renderer2.setAttribute(iframe, 'nonce', this.nonce);
      }
      this._renderer2.addClass(iframe, 'tawk-iframe');
      if (iframe.style.cssText) {
        this.convertInlineStyleToStyleElement(iframe, iframe.style.cssText, 'tawk');
      }
      console.log('[Tawk.to] Iframe processed:', iframe.src);
    } catch (error) {
      console.error('[Tawk.to] Error processing iframe:', error);
    }
  }

  private processStyleElement(style: HTMLStyleElement): void {
    try {
      if (!style.getAttribute('nonce')) {
        console.warn('[CSP] New style tag detected without nonce:', style.textContent?.substring(0, 50) + '...');
        this._renderer2.setAttribute(style, 'nonce', this.nonce);
        console.log('[CSP] Successfully applied nonce to style tag:', style.id || 'unnamed', 'Nonce:', this.nonce);
      }
    } catch (error) {
      console.error('[CSP] Error processing style element:', error);
    }
  }

  private convertInlineStyleToStyleElement(element: HTMLElement, inlineStyle: string, prefix: string): void {
    if (!inlineStyle || !this.nonce) return;
    try {
              const className = `${prefix}-style-${Math.random().toString(36).substr(2, 9)}`;
       const existingStyles = Array.from(this._document.head.getElementsByTagName('style'));
        const styleExists = existingStyles.some(style => style.textContent === `.${className} { ${inlineStyle} }`);

      if (!styleExists) {

        const styleElement = this._renderer2.createElement('style');
        this._renderer2.setAttribute(styleElement, 'nonce', this.nonce);
        this._renderer2.setProperty(styleElement, 'textContent', `.${className} { ${inlineStyle} }`);

        // Check if a style element with same content already exists
       
        this._renderer2.addClass(element, className);
        this._renderer2.addClass(element, 'tawk-style'); // Mark as processed
        this._renderer2.removeAttribute(element, 'style');
        this._renderer2.appendChild(this._document.head, styleElement);
        console.log(`[CSP] Converted inline style to CSS class: ${className}`);
      } else {
        console.log(`[CSP] Style already exists for class: ${className}, skipping append`);
      }
    } catch (error) {
      console.error('[CSP] Error converting inline style:', error);
    }
  }

  private applyTawkGlobalStyles(): void {
    const styleId = 'tawk-global-styles';
    if (this._document.getElementById(styleId)) {
      console.log('[Tawk.to] Global styles already exist, skipping application');
      return;
    }

    const styleElement = this._renderer2.createElement('style');
    this._renderer2.setAttribute(styleElement, 'id', styleId);
    this._renderer2.setAttribute(styleElement, 'nonce', this.nonce);
    const globalStyles = `
      .tawk-container {
        position: fixed !important;
        bottom: 25px !important;
        right: 25px !important;
        z-index: 1000002 !important;
        width: 300px !important;
        height: 400px !important;
      }
      .tawk-container iframe[src*="tawk.to"], .tawk-container .tawk-iframe {
        width: 100% !important;
        height: 100% !important;
        border: none !important;
      }
      .widget-visible {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        padding: 20px !important;
        z-index: 1000002 !important;

      }
      .tawk-button-hover:focus, .tawk-button-hover:hover {
        background: #333 !important;
        color: #fff !important;
      }
      @keyframes tawkMaxOpen {
        0% { opacity: 0; transform: translate(0, 100%); }
        100% { opacity: 1; transform: translate(0, 0); }
      }
      @media (max-width: 767px) {
        .tawk-container, .widget-visible {
          top: calc(85% - 0px) !important;
          bottom: auto !important;
        }
        .widget-visible {
          flex-direction: column !important;
        }
      }
      @media (min-width: 768px) {
        .widget-visible {
          flex-direction: initial !important;
          padding: 20px !important;
          z-index: 1000002 !important;
        }
      }
    `;
    this._renderer2.setProperty(styleElement, 'textContent', globalStyles);
    this._renderer2.appendChild(this._document.head, styleElement);
    console.log('[Tawk.to] Applied global styles with ID:', styleId);
  }

  private processIframesAndStyles(): void {
    try {
      // Process iframes
      const iframes: any = Array.from(this._document.getElementsByTagName('iframe'));
      iframes.forEach((iframe: HTMLIFrameElement) => {
        if (!iframe.getAttribute('nonce')) {
          this._renderer2.setAttribute(iframe, 'nonce', this.nonce);
        }
        if (iframe.src?.includes('tawk.to')) {
          this._renderer2.addClass(iframe, 'tawk-iframe');
          if (iframe.style.cssText) {
            this.convertInlineStyleToStyleElement(iframe, iframe.style.cssText, 'tawk');
          }
        }
      });

      // Process style tags
      const styles = Array.from(this._document.getElementsByTagName('style')).filter(
        style => !style.getAttribute('nonce') && !style.id.includes('tawk-global-styles')
      );
      styles.forEach((style) => this.processStyleElement(style));

      // Process inline styles
      const styledElements = Array.from(this._document.getElementsByTagName('*')).filter(
        el => el.hasAttribute('style') && !el.className.includes('tawk-style')
      );
      styledElements.forEach((el) =>
        this.convertInlineStyleToStyleElement(el as HTMLElement, el.getAttribute('style')!, 'tawk')
      );
    } catch (error) {
      console.error('[CSP] Error processing iframes and styles:', error);
    }
  }

  private processIframes(): void {
    try {
      const iframes = Array.from(this._document.getElementsByTagName('iframe'));
      iframes.forEach((iframe: HTMLIFrameElement) => {
        if (!iframe.getAttribute('nonce')) {
          this._renderer2.setAttribute(iframe, 'nonce', this.nonce);
        }
        if (iframe.src?.includes('tawk.to')) {
          this._renderer2.addClass(iframe, 'tawk-iframe');
          if (iframe.style.cssText) {
            this.convertInlineStyleToStyleElement(iframe, iframe.style.cssText, 'tawk');
          }
        }
      });
    } catch (error) {
      console.error('[CSP] Error processing iframes:', error);
    }
  }
  private setupCSP() {
    const cspContent = [
      "default-src 'none'",
        "base-uri 'self'",
        `script-src 'strict-dynamic' 'nonce-${this.nonce}' https://www.googletagmanager.com/ https://www.google-analytics.com/ https://www.clarity.ms/ https://googleads.g.doubleclick.net/ https://connect.facebook.net/ https://accounts.google.com/ https://www.googleadservices.com/ https://assets.snapmint.com/ https://embed.tawk.to/ https://cdn.jsdelivr.net/ https://merchant-js.snapmint.com/ *.ccavenue.com`,
        `style-src 'self' 'nonce-${this.nonce}' https://fonts.googleapis.com/ https://cdn.jsdelivr.net/ https://assets.snapmint.com/ https://embed.tawk.to https://*.tawk.to`,
        `style-src-elem 'self' 'nonce-${this.nonce}' https://fonts.googleapis.com/ https://cdn.jsdelivr.net/  https://www.googletagmanager.com/ https://www.google-analytics.com/ https://accounts.google.com/ https://assets.snapmint.com/ https://embed.tawk.to https://*.tawk.to`,
        "img-src 'self'  https://lumprodsta.blob.core.windows.net/  https://lumprodblobcdn.azureedge.net/ https://www.google-analytics.com/ https://www.facebook.com/ https://www.google.com/ https://www.google.co.in/ https://*.clarity.ms/ https://c.bing.com/ https://googleads.g.doubleclick.net/ https://lumprodsta.blob.core.windows.net/ https://www.googletagmanager.com/ https://embed.tawk.to/ https://assets.snapmint.com/assets/ https://lumprodsta.blob.core.windows.net/ https://lum-prod-blog-app.azurewebsites.net/",
        "font-src 'self' https://fonts.gstatic.com/ https://embed.tawk.to/",
        "connect-src 'self' https://prodapi.luminousindia.com/ https://lumprodblobcdn.azureedge.net/ https://lumprodsta.blob.core.windows.net/ https://www.googletagmanager.com/ https://connect.facebook.net/ https://accounts.google.com/ https://botqa.luminousindia.com/ https://analytics.google.com/ https://www.google.com/ https://www.google-analytics.com/ https://*.clarity.ms/ https://stats.g.doubleclick.net/ https://va.tawk.to/ wss://*.tawk.to/ https://embed.tawk.to/ https://www.google.co.in/ https://api.snapmint.com/v3/public/online_checkout",
        "frame-src 'self'https://www.googletagmanager.com/ https://td.doubleclick.net/ https://www.youtube.com/ https://accounts.google.com/ https://embed.tawk.to/ https://secure.ccavenue.com https://*.snapmint.com https://api.snapmint.com/v3/public/online_checkout https://www.facebook.com/tr https://accounts.google.com",
        "child-src 'self'  https://embed.tawk.to ",
        "form-action 'self' https://secure.ccavenue.com https://*.snapmint.com https://api.snapmint.com/v3/public/online_checkout https://www.facebook.com/tr https://accounts.google.com",
        "manifest-src 'self' manifest.webmanifest",
        "media-src 'self' ",
        "frame-ancestors 'self' ",
        "object-src 'none'",
        "manifest-src 'self' manifest.webmanifest",
        "upgrade-insecure-requests",
        "report-to default"
    ].join('; ');
    this.meta.updateTag({
      'http-equiv': 'Content-Security-Policy',
      content: cspContent
    });
    this.addNonceToExistingElements();
    console.log('[CSP] Applied CSP with nonce:', this.nonce);
  }

  private addNonceToExistingElements(): void {
    if (!this.nonce) return;
    const scripts = this._document.getElementsByTagName('script');
    for (let script of Array.from(scripts)) {
      if (!script.hasAttribute('src') && !script.hasAttribute('nonce') && script.innerHTML.trim() !== '') {
        this._renderer2.setAttribute(script, 'nonce', this.nonce);
      }
    }
    const styles = this._document.getElementsByTagName('style');
    for (let style of Array.from(styles)) {
      if (!style.hasAttribute('nonce') && style.innerHTML.trim() !== '') {
        this._renderer2.setAttribute(style, 'nonce', this.nonce);
      }
    }
    const links = this._document.getElementsByTagName('link');
    for (let link of Array.from(links)) {
      if (link.getAttribute('rel') === 'stylesheet' && !link.hasAttribute('nonce')) {
        this._renderer2.setAttribute(link, 'nonce', this.nonce);
      }
    }
  }

  private isRedirecting = false;
  private redirectedUrls: Set<string> = new Set();
  private checkRedirect(currentUrl: string): void {
    if (this.isRedirecting) {
      return;
    }
    if (this.redirectedUrls.has(currentUrl)) {
      this.isRedirecting = false;
      return;
    }
    this.isRedirecting = true;
    this.sub.add(
      this.redirectService.getRedirectUrl(currentUrl).pipe(take(1)).subscribe({
        next: (data: any) => {
          if (data && data.url && this.isValidRelativeUrl(data.url)) {
            if (data.url !== currentUrl) {
              this.redirectedUrls.add(data.url);
              this.router.navigateByUrl(data.url).then(() => {
                this.isRedirecting = false;
              }).catch((err) => {
                console.error('Navigation error:', err);
                this.isRedirecting = false;
              });
            } else {
              this.redirectedUrls.add(currentUrl);
              this.isRedirecting = false;
            }
          } else {
            const isValidRoute = this.isValidAppRoute(currentUrl);
            if (currentUrl === '' || currentUrl === '/' || isValidRoute) {
              this.redirectedUrls.add(currentUrl);
              this.isRedirecting = false;
            } else {
              this.redirectedUrls.add('/not-found');
              this.router.navigateByUrl('/not-found').then(() => {
                this.isRedirecting = false;
              }).catch((err) => {
                console.error('Navigation to not-found page failed:', err);
                this.isRedirecting = false;
              });
            }
          }
        },
        error: (err: any) => {
          console.error('Error fetching redirect URL:', err);
          const isValidRoute = this.isValidAppRoute(currentUrl);
          if (currentUrl === '' || currentUrl === '/' || isValidRoute) {
            this.redirectedUrls.add(currentUrl);
            this.isRedirecting = false;
          } else {
            this.redirectedUrls.add('/not-found');
            this.router.navigateByUrl('/not-found').then(() => {
              this.isRedirecting = false;
            }).catch((err) => {
              console.error('Navigation to not-found page failed:', err);
              this.isRedirecting = false;
            });
          }
        }
      })
    );
  }

  private isValidRelativeUrl(url: string): boolean {
    return url.startsWith('/');
  }

  private isValidAppRoute(url: string): boolean {
    const normalizedUrl = url.startsWith('/') ? url.slice(1) : url;
    const urlWithoutParams = normalizedUrl.split('?')[0];
    const routes = this.router.config;
    return routes.some(route => {
      if (route.path === urlWithoutParams) {
        return true;
      }
      if (route.children) {
        return route.children.some(child => {
          const fullChildPath = route.path ? `${route.path}/${child.path}` : child.path;
          if (fullChildPath === urlWithoutParams) {
            return true;
          }
          return false;
        });
      }
      if (route.path && route.path.includes(':')) {
        const routeSegments = route.path.split('/');
        const urlSegments = urlWithoutParams.split('/');
        if (routeSegments.length === urlSegments.length) {
          const isMatch = routeSegments.every((segment, i) => {
            return segment.startsWith(':') || segment === urlSegments[i];
          });
          if (isMatch) {
            return true;
          }
        }
      }
      return false;
    });
  }

  @HostListener('document:visibilitychange', ['$event'])
  onFocus(event: any): void {
    if (isPlatformBrowser(this.platformId)) {
      if (document.visibilityState === 'visible') {
        if (this.utils.getToken()) {
          const authInformation: any = this.SigninService.getAuthData();
          const now = new Date();
          const expiresInDuration = authInformation.expirationDate.getTime() - now.getTime();
          if (expiresInDuration <= 0) {
            this.utils.showLoading();
            this.SigninService.RefreshTokenWithCallback((x: any) => {
              this.utils.hideLoading();
            });
          }
        }
        if ((!this.utils.getToken() && this.SigninService.getIsAuth()) || (this.utils.getToken() && !this.SigninService.getIsAuth()) || (this.utils.userPinCode != this.utils.getUserPicode())) {
          location.reload();
        }
      }
    }
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(_event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkCookiesModel();
    }
  }

  checkCookiesModel() {
    if (isPlatformBrowser(this.platformId)) {
      let cokkieAcceptance: any = this.utils.getItemFromLocalStorage('lms_cookies');
      if (localStorage && !cokkieAcceptance && !this.isCookieModelOpened) {
        this.isCookieModelOpened = true;
        const dialogRef = this.dialog.open(SharedModelComponent, {
          disableClose: true,
          panelClass: 'cookiesModel',
          data: { cookiesSection: true },
          ariaLabelledBy: 'cookiesModelTitle',
          ariaDescribedBy: 'cookiesModelDescription'
        });
        this.sub.add(dialogRef.afterClosed().subscribe((res: any) => {
          this.utils.setItemToLocalStorage('lms_cookies', res);
        }));
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  screenWidth() {
    this.setViewSize(window.innerWidth, window.innerHeight);
  }

  @HostListener('window:onload', ['$event'])
  getScreenWith() {
    this.setViewSize(window.innerWidth, window.innerHeight);
  }

  setViewSize(width: any, height: any) {
    this.utils.screenSizeObj.width = width;
    this.utils.screenSizeObj.height = height;
    switch (true) {
      case width < 576:
        this.utils.screenSizeObj.type = 'mobile';
        break;
      case width < 768:
        this.utils.screenSizeObj.type = 'tab';
        break;
      case width >= 768:
        this.utils.screenSizeObj.type = 'desktop';
        break;
      default:
        this.utils.screenSizeObj.type = 'not defined';
        break;
    }
  }

  clearCart() {
    if (!this.utils.getUser()) {
      let timeStamp: any = new Date().getTime();
      let startTime: any = localStorage.getItem('startTime');
      if (timeStamp - startTime > 2 * 60 * 60 * 1000) {
        this.CartService.clearInfo();
        localStorage.removeItem('startTime');
      }
    }
  }

  getCartItems() {
    this.CartService.loadInfo();
    if (this.utils.getToken()) {
      this.sub.add(this.CartService.getItems().subscribe({
        next: (response: any) => {
          const encryptedCart: any = localStorage.getItem('cart');
          const cartItems = this.utils.decryptarrayText(encryptedCart);
          if(cartItems && cartItems != null && cartItems != "null")
          this.cartInfo$ = JSON.parse(cartItems);
          if (response.success) {
            if (this.cartInfo$ && this.cartInfo$.length) {
              this.CartService.processCartItems(this.cartInfo$, response, (updateCart: any) => {
                if (updateCart) {
                  this.sub.add(this.service.checkout().subscribe((data: any) => { }));
                }
              }, (_emptyCart: any) => {
                this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                this.CartService.clearInfo();
                this.sub.add(this.service.checkout().subscribe((data: any) => { }));
              }, false, this.utils.isRecentLogin ? true : false);
            } else {
              if (response.cartDetailList && response.cartDetailList.length) {
                this.utils.setUserPicode(response.cartDetailList[0].pincode);
                this.CartService.setInfo(response.cartDetailList, false);
              }
            }
          } else {
            if (response && (response.statusCode != "204" && response.message != 'Record not found')) {
              this.CartService.clearInfo();
              this.utils.openSnackBar(response.message, 'error-toster');
            } else {
              if (this.cartInfo$ && this.cartInfo$.length) {
                this.CartService.processCartItems(this.cartInfo$, response, (updateCart: any) => {
                  if (updateCart) {
                    this.sub.add(this.service.checkout().subscribe((data: any) => { }));
                  }
                }, (_emptyCart: any) => {
                  this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                  this.CartService.clearInfo();
                  this.sub.add(this.service.checkout().subscribe((data: any) => { }));
                }, false, this.utils.isRecentLogin ? true : false);
              }
            }
          }
        }
      }));
    }
  }

  ngOnDestroy(): void {
    if (this.updateVar) this.updateVar.unsubscribe();
    if (this._routerSub) this._routerSub.unsubscribe();
    this.sub.unsubscribe();
  }
}